import type { Meta, StoryObj } from '@storybook/angular';
import { moduleMetadata } from '@storybook/angular';
import { expect } from 'storybook/test';
import { ProductRightComponent } from '../../app/content/modules/page/components/product/components/product-right/product-right.component';
import { withCommonDecorators } from '../_utils/story-helpers';
import { createDamilanoBarberaProduct, createDiscountedProduct, createProductWithRatings, createLastBottlesProduct, createDiscountCountdownProduct } from '../_mocks/wine-product.mock';

const meta: Meta = {
  title: 'Compositions/Product Detail - Buy Section',
  tags: ['autodocs'],
  decorators: [
    ...withCommonDecorators(),
    moduleMetadata({
      imports: [ProductRightComponent],
    }),
  ],
  parameters: {
    docs: {
      description: {
        component: 'Composition of product detail page buy section — the right side of the PDP showing badges, ratings, price table, and add-to-cart.',
      },
    },
  },
};
export default meta;
type Story = StoryObj;

const product = createDamilanoBarberaProduct();
const discounted = createDiscountedProduct();
const rated = createProductWithRatings();

export const RegularProduct: Story = {
  render: () => ({
    template: `
      <div style="max-width: 500px; padding: 20px;">
        <app-product-right [product]="product"></app-product-right>
      </div>
    `,
    props: { product },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-right')).toBeTruthy();
  },
};

export const DiscountedProduct: Story = {
  render: () => ({
    template: `
      <div style="max-width: 500px; padding: 20px;">
        <app-product-right [product]="product"></app-product-right>
      </div>
    `,
    props: { product: discounted },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-right')).toBeTruthy();
  },
};

export const HighlyRatedProduct: Story = {
  render: () => ({
    template: `
      <div style="max-width: 500px; padding: 20px;">
        <app-product-right [product]="product"></app-product-right>
      </div>
    `,
    props: { product: rated },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-right')).toBeTruthy();
  },
};

export const OutOfStockProduct: Story = {
  render: () => ({
    template: `
      <div style="max-width: 500px; padding: 20px;">
        <app-product-right [product]="product"></app-product-right>
      </div>
    `,
    props: {
      product: createDamilanoBarberaProduct({ inStock: false, stock: 0, title: 'Château Margaux 2020 – Udsolgt' }),
    },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-right')).toBeTruthy();
  },
};

export const LastBottlesProduct: Story = {
  render: () => ({
    template: `
      <div style="max-width: 500px; padding: 20px;">
        <app-product-right [product]="product"></app-product-right>
      </div>
    `,
    props: { product: createLastBottlesProduct() },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-right')).toBeTruthy();
  },
};

export const DiscountCountdownProduct: Story = {
  render: () => ({
    template: `
      <div style="max-width: 500px; padding: 20px;">
        <app-product-right [product]="product"></app-product-right>
      </div>
    `,
    props: { product: createDiscountCountdownProduct() },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-right')).toBeTruthy();
  },
};
